export const logo = "https://media.graphassets.com/BldVa3tyRDy2QkoyQq9R"